<template>
    <div>
        <TopNavigation  class="topNavigation"></TopNavigation>
        <div class="line"></div>
        <!-- 船东SPOT -->
        <div class="cometnt">
            <div class="left">
                <div class="qc_con">
                    <p class="qc_tit">全程贴心服务与您同在</p>
                    <p class="qc_word">订好舱集成主流船东电商和一手庄家舱位的在线服务平台</p>
                </div>
            </div>
            <div class="right"></div>
            <div class="search">
                <FreightRate />
            </div>
        </div>
        <Bottom /> 
        
    </div>
</template>

<script>
// 底部
import Bottom from '../HP/BottomPage.vue';
import TopNavigation from "../HP/TopNavigationB.vue";
import FreightRate from "../HP/FreightRate copy.vue";

export default {
    components:{
        Bottom,
        TopNavigation,
        FreightRate,
    },
    setup() {
        
    },
}
</script>

<style lang="scss" scoped>
.topNavigation{
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
}
.line{
    height: 1px;
    background: #EEEEEE;
    border-radius: 0px 0px 0px 0px;
}

.cometnt{
    display: flex;
    justify-content: space-between;
    position: relative;
}

// .left{
//     background: paleturquoise;
// }

.qc_con{
    margin-top: 80px;
    margin-left: 360px ;
    .qc_tit{
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 32px;
        color: #333333;
        line-height: 38px;
        text-align: left;
        font-style: normal;
        text-transform: none;
    }
    .qc_word{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #999999;
        line-height: 28px;
        text-align: left;
        font-style: normal;
        text-transform: none;
    }
}

.right{
    width: 620px;
    height: 668px;
    background-image:url('../../assets/images/login/beijing.png');	
    background-repeat: no-repeat;
    background-size:100% 100%;
}

.search{
    position: absolute;
    top: 220px;
    left: 50%;
    transform: translate(-50%);
    // background: #fff;

    // width: 1200px;
    // // height: 320px;
    // background: #FFFFFF;
    // box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.03);
    // border-radius: 12px 12px 12px 12px;
    // border: 1px solid #E4E6E8;
}
</style>